
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tag/create",
      function () {
        return require("private-next-pages/tag/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tag/create"])
      });
    }
  